import { Grid, Segmented } from "antd";
import { useJourneyStaticDetails } from "../../../../context";
import { SSR_OPTION_SKELETONS } from "src/Modules/Flights/constants/JourneyDetails";
import { useSSRContext } from "../../context/SSRContext";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import classNames from "classnames";
import { track } from "@amplitude/analytics-browser";

export default function SSRSelection() {
  const { cursor,SSROptions, handleChange } = useSSRContext();
  const { journeyDetails } = useJourneyStaticDetails();
  const { isFetching } = journeyDetails;
  const handleSSRChange = (value:string)=>{
    handleChange("ssrType",value)();
    track("SSR Changed",{
      value
    })
  }
  const isSegmented = SSROptions.length > 1;
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const options = SSROptions.map((option)=>{
    return {
      ...option,
      icon:null,
    };
  })
  if (isFetching) return SSR_OPTION_SKELETONS;
  if (isSegmented)
    return (
      <Segmented
        options={options as any}
        value={cursor.ssrType}
        onChange={handleSSRChange}
        shape="round"
        seamless={false}
        block={isLargeScreen}
        classNames={{
          root: classNames("rounded-full! p-2! bg-background-default! border! border-border-default! flex! justify-center! w-min", !isLargeScreen && "w-full!"),
          label: "py-1! md:px-5! flex! items-center! md:gap-1.5! flex-1! justify-center!",
          item:"flex-1! flex! items-center! justify-center! md:text-18! text-sm! md:px-4! px-3!",
          icon:"h-6! w-6!"
        }}
      />
    );
    return null;
}
